<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Beerdigung und Trauerfeier</h3>
      </div>
    </div>
    <div class="section section-work-images">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-1.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-2.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-3.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-4.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-5.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-6.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-7.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-8.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-9.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-10.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-11.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-12.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-13.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-14.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/funeral/funeral-15.jpg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'funeral',
  bodyClass: 'funeral-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
